import { Autocomplete, Box, Button, CircularProgress, FormControl, FormHelperText, Grid, TextField, Typography } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useState,useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { BookingService } from '../../Service';
import Swal from 'sweetalert2';

const ReschedulingForm = ({onClose,onCancel}) => {
    const {bookingId} = useParams();
    const { control, handleSubmit, setValue, formState: { errors ,isDirty},watch,reset } = useForm({
        mode: "onChange",
        defaultValues:{
          serviceDate:'',
          timeSlot:'',
          message:'',
        }
      });
    
      const [loadingTimeSlotList,setLoadingTimeSlotList] = useState(false);
      const [timeSlotList,setTimeSlotList] = useState([]);
      
      const selectedDate= watch('serviceDate');
    
      useEffect(()=>{
        if (selectedDate && bookingId) {
            setValue('timeSlot','')
            const fetchTimeSlots= async()=>{
              setLoadingTimeSlotList(true);
              try {
                const timeSlotResponse = await BookingService.fetchProviderTimeSlot({
                  "bookingId": bookingId,
                  "timeSlotDate": selectedDate,                      
                });
                if(timeSlotResponse.success=="1"){
                  if (timeSlotResponse?.data.length>0) {
                    setTimeSlotList(timeSlotResponse.data);
                  } else {
                    Swal.fire('Time Slot for selected Date not available','','error');
                    setValue('serviceDate','')
                  }
                  
                }else{
                  Swal.fire(timeSlotResponse.message,'','error');
                }
              } catch (error) {
    
              }finally{
                setLoadingTimeSlotList(false);
              }
            }
            fetchTimeSlots();
        }
      },[selectedDate])
    
      const [isFormSubmitting, setIsFormSubmitting] = useState(false);
    
      const onSubmit=async(data)=>{
        // setIsFormSubmitting(true);
        const timeJson = JSON.parse(data?.timeSlot);
        const requiredData = {
            message: data.message,
            timeSlotDate: data.serviceDate,
            startTime: timeJson.startTime,
            endTime: timeJson.endTime,
        }
        console.log("requiredData",requiredData);
        onClose(requiredData);
        
    }
    return (
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} >
                {/* ............left section................... */}
                <Grid item xs={12} lg={5}>
                    <Grid container>
                        <Grid item xs={12} sx={{my:'1%'}}>
                            <Grid container sx={{mb:'1%'}}>
                                <Grid item lg={7} xs={12}>
                                    <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins'}}>Select Date<span style={{color:'#d32f2f'}}>*</span></Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={12} xs={12}>
                                    <Controller
                                        name="serviceDate"
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                            if (!value) return "This field is required";
                                            const date = dayjs(value);
                                            const today = dayjs().startOf('day');
                                            return date.isValid() && (date.isSame(today, 'day') || date.isAfter(today)) || "Booking Date must be today or in the future";
                                            }
                                        }}
                                        render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                {...restField}
                                                sx={{
                                                '& . iconButton': {
                                                    padding: 0.5,
                                                    fontSize: '1rem'
                                                }
                                                }}
                                                // disabled={!watch('services').length>0 || !watch('customer')}
                                                value={value ? dayjs(value) : null}
                                                onChange={(newValue) => {
                                                    // Store the date in YYYY-MM-DD format for database compatibility
                                                    onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                                }}
                                                format="DD-MM-YYYY" // Display format for user
                                                minDate={dayjs()}
                                                slotProps={{
                                                textField: {
                                                    error: !!error,
                                                    helperText: error?.message,
                                                    fullWidth: true,
                                                    required: true,
                                                    size: 'small',
                                                    inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                    }
                                                }
                                                }}
                                            />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* ............central gap................... */}
                <Grid item xs={'none'} lg={2}>
                    
                </Grid>
                {/* ............right section................... */}
                <Grid item xs={12} lg={5}>
                    <Grid container>
                        <Grid item xs={12} sx={{my:'1%'}}>
                            <Grid container sx={{mb:'1%'}}>
                                <Grid item lg={7} xs={12}>
                                    <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins'}}>Select Time Slot<span style={{color:'#d32f2f'}}>*</span></Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={loadingTimeSlotList?'10':'12'} xs={12}>
                                
                                    <Controller
                                        name="timeSlot"
                                        control={control}
                                        rules={{
                                        required: 'Please select a time slot',
                                        }}
                                        render={({ field, fieldState: { error } }) => (
                                        <FormControl error={!!error} fullWidth>
                                            <Autocomplete
                                                id="time-slot-autocomplete"
                                                options={timeSlotList}
                                                // sx={{
                                                //   display: services.length > 0 ? 'block' : 'none',
                                                // }}
                                                disabled={!watch('serviceDate')}
                                                getOptionLabel={(option) => {
                                                    // Handle both string (from field value) and object (from options) cases
                                                    // const slot = typeof option === 'string' ? JSON.parse(option) : option;
                                                    return `${dayjs(option.startTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(option.endTime, 'HH:mm:ss').format('h:mm A')}`;
                                                }}
                                                isOptionEqualToValue={(option, value) => {
                                                    // Handle both string and object cases for comparison
                                                    const valueObj = typeof value === 'string' ? JSON.parse(value) : value;
                                                    return option.startTime === valueObj.startTime && option.endTime === valueObj.endTime;
                                                }}
                                                value={field.value ? (typeof field.value === 'string' ? JSON.parse(field.value) : field.value) : null}
                                                onChange={(_, newValue) => {
                                                    field.onChange(newValue ? JSON.stringify(newValue) : null);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { fontSize: '0.75rem',color:'#000' },
                                                        }}
                                                        placeholder="Select Time Slot"
                                                        variant="outlined"
                                                        error={!!error}
                                                        size="small"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    sx: {
                                                    '& .MuiAutocomplete-option': {
                                                        padding: '8px 16px',
                                                        fontSize: '0.75rem',
                                                        '&:hover': {
                                                        backgroundColor: '#f5f5f5',
                                                        },
                                                    },
                                                    },
                                                }}
                                            />
                                            {error && <FormHelperText>{error.message}</FormHelperText>}
                                        </FormControl>
                                        )}
                                    />
                                </Grid>
                                
                                {loadingTimeSlotList && <Grid item xs={2}><CircularProgress size={'2.1rem'} /></Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* ............right section ends................... */}
                <Grid item xs={12} sx={{my:'1%'}}>
                    <Controller
                        control={control}
                        name="message"
                        rules={{
                            required: 'Enter Reason for Rescheduling',
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                label="Reason for Rescheduling*"
                                fullWidth
                                multiline
                                rows={3}
                                error={!!error}
                                helperText={error ? error.message : null}
                                variant="outlined"
                                size="small"
                                inputProps={{
                                    style: { fontSize: '0.75rem' },
                                }}
                            />
                        )}
                        
                    />
                </Grid>
                <Grid item xs={12} sx={{my:'1%'}}>
                    <Box sx={{display:'flex',justifyContent:'flex-end',gap:2}}>
                        <Button variant='outlined' size='small' onClick={onCancel}>Cancel</Button>
                        <Button variant='contained' size='small' type="submit" disabled={isFormSubmitting || !isDirty} >Submit</Button>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    );
}

export default ReschedulingForm;
